module.exports = __webpack_public_path__ + "media/images/lps-buy_housing-a6625337.png";